import React from 'react';

import { Wrapper } from './Feature.styled';

export interface Props {
    name: string;
    hasFeature: boolean;
}

const Feature: React.FC<Props> = props => {
    const { name, hasFeature } = props;

    return (
        <Wrapper>
            {hasFeature ? (
                <span aria-label={`Has feature ${name}`}>Yes</span>
            ) : (
                <span aria-label={`Doesn't have feature ${name}`}>None</span>
            )}
        </Wrapper>
    );
};

export default Feature;
